import React, { Component } from 'react';
import HTMLReactParser from 'html-react-parser';

// Components
import VideoPlayer from "../components/VideoPlayer";
import service from "../common/service"
import { Link } from 'react-router-dom';
import { parseDragMeta } from '@fullcalendar/core';

let sub;
class HeroHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscribeMsg: false,
            popup: false,
            form_popup: false,
            popup_title: "",
            popup_note: [],
            header: {}
        }
        this.apiServe = new service();
    }
    componentDidMount() {
        this.getHeaderInfo();
        sub = this.apiServe.getevent().subscribe((response) => {
            if (this.props.preData ?.tabData == 'howToFestInPerson') {
                switch (response.event) {
                    case "howToFestOnline|header|getDetail":
                        if (response.error) {
                        }
                        else {
                            this.setState({
                                header: response.data
                            })
                        }
                        break;

                    case "howToFestInPerson|header|getDetail":
                        if (response.error) {
                        }
                        else {
                            this.setState({
                                header: this.props.preData
                            })
                        }
                        break;

                    default:
                        break;
                }
            }
            else if (this.props.preData ?.tabData == 'howToFestOnline') {
                switch (response.event) {
                    case "howToFestOnline|header|getDetail":
                        if (response.error) {
                        }
                        else {
                            this.setState({
                                header: this.props.preData
                            })
                        }
                        break;

                    case "howToFestInPerson|header|getDetail":
                        if (response.error) {
                        }
                        else {
                            this.setState({
                                header: response.data
                            })
                        }
                        break;

                    default:
                        break;
                }
            }
            else {
                switch (response.event) {
                    case "howToFestOnline|header|getDetail":
                        if (response.error) {
                        }
                        else {
                            this.setState({
                                header: response.data
                            })
                        }
                        break;

                    case "howToFestInPerson|header|getDetail":
                        if (response.error) {
                        }
                        else {
                            this.setState({
                                header: response.data
                            })
                        }
                        break;

                    default:
                        break;
                }
            }
        })
    }

    // call event 
    getHeaderInfo() {
        if (this.props.HTFonlinelink) this.apiServe.sendevent("howToFestInPerson|header|getDetail", {})
        else this.apiServe.sendevent("howToFestOnline|header|getDetail", {})
    }

    // Play Video
    playVideo = () => {
        let video = document.querySelector("#sd_video");

        if (video.paused) {
            video.play();
            document
                .querySelector("#sd_video_control_wpr")
                .classList.add("sd_hidden");
        }
    };

    render() {

        const { header } = this.state;
        // const linkName = this.props.history.location.pathname;
        // console.log('linkName',linkName);
        // console.log('header',header);
        return (
            <>
            {Object.keys(header).length !== 0 &&
                <div className={`sd_hero_header sd_sponsors_header sd_herobanner ${this.props.newbanner ? 'new_banner' : ''}`}>
                    <div className="sd_inner_container">
                        <div className="sd_hero_header_inner">
                            {this.props.HTFonlinelink ?
                                <>
                                <Link className="sd_fest_online_link" onClick={this.props.onlinelink}>
                                    {console.log('online')}
                                    <p> Learn How to Fest Online </p>
                                    <img src={`${process.env.REACT_APP_IMAGE_PATH}slider_arrow_right.svg`} alt="Arrow" title="Arrow" />
                                </Link>
                                </> :
                                <>
                                {console.log('inperson')}
                                <Link className="sd_fest_online_link" onClick={this.props.onlinelink}>
                                    <p> Learn How to Fest In-Person </p>
                                    <img src={`${process.env.REACT_APP_IMAGE_PATH}slider_arrow_right.svg`} alt="Arrow" title="Arrow" />
                                </Link>
                                </>
                            }
                            <div className="sd_hero_header_wpr">
                                <div className="sd_hero_header_text">
                                    <h1 className="sd_textuppercase"> {header.title} </h1>
                                    <div className="sd_rtf_content">
                                        {HTMLReactParser(header.description)}
                                    </div>
                                </div>

                                <div className="sd_hero_header_video sd_video_wpr">

                                    <div className="sd_hero_header_videor_inner">
                                        {/* {
                                                header.media && header.media.inSite && header.media.inSite.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ?
                                                    <img src={this.apiServe.imageUrl + header.media.inSite} 
                                                        alt="Fest Title" title="Fest Title" 
                                                    /> 
                                                :
                                                <VideoPlayer autoplay={false} videoSrc={this.apiServe.imageUrl + header.media.inSite} />
                                            } */}

                                        {/* {
                                                header.media && header.media?.inSite
                                                    ? header.media.inSite?.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                                        ? <div className="sd_home_fest_slider_block">
                                                            <img src={header.media.inSite.includes('http')
                                                                ? header.media.inSite
                                                                : this.apiServe.imageUrl + header.media.inSite} 
                                                                alt="Fest Title" title="Fest Title" 
                                                            />
                                                        </div>
                                                        : <div className="sd_home_fest_slider_block sd_video_wpr">
                                                            <VideoPlayer
                                                                videoSrc={header.media.inSite.includes('http') ? header.media.inSite : this.apiServe.imageUrl + header.media.inSite}
                                                                autoplay={false}
                                                                loop={true}
                                                            />
                                                        </div>
                                                    : header.media?.link?.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                                        ? <div className="sd_home_fest_slider_block">
                                                            <img src={header.media?.link} alt="Fest Title" title="Fest Title" />
                                                        </div>
                                                        : 
                                                        // <div className="sd_home_fest_slider_block sd_video_wpr">
                                                        //     <VideoPlayer
                                                        //         videoSrc={header.media?.link} 
                                                        //         autoplay={false}
                                                        //         loop={true}
                                                        //     />
                                                        // </div>
                                                        <>
                                                        <div className="iframeContainer ">
                                                        <iframe
                                                        src={
                                                                 header.media?.link && header.media?.link +
                                                                "?enablejsapi=1&version=3&playerapiid=ytplayer"
                                                        }
                                                        ></iframe>
                                                    </div>
                                                    </>
                                            } */}

                                        {header && header.media && header.media.map((item, index) => {
                                            return (
                                                item.inSite
                                                    ? item.inSite ?.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                                        ? <div className="sd_home_fest_slider_block" key={index}>
                                                            <img src={item.inSite.includes('http')
                                                                ? item.inSite
                                                                : this.apiServe.imageUrl + item.inSite}
                                                                alt="Fest Title" title="Fest Title"
                                                            />
                                                        </div>
                                                        :
                                                        <div className="sd_home_fest_slider_block sd_video_wpr" key={index}>

                                                            <VideoPlayer
                                                                videoSrc={item.inSite.includes('http') ? item.inSite : this.apiServe.imageUrl + item.inSite}
                                                                autoplay={false}
                                                                loop={true}
                                                            />
                                                        </div>
                                                        : item.link ?.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                                            ? <div className="sd_home_fest_slider_block" key={index}>
                                                                <img src={item.link} alt="Fest Title" title="Fest Title" />
                                                            </div>
                                                            :
                                                            // <div className="sd_home_fest_slider_block sd_video_wpr" key={index}>
                                                            //     <VideoPlayer
                                                            //         videoSrc={item.link} 
                                                            //         autoplay={false}
                                                            //         loop={true}
                                                            //     />
                                                            // </div>
                                                            <div className="iframeContainer sd_home_fest_slider_block sd_video_wpr" key={index}>
                                                                <iframe
                                                                    src={
                                                                        item.link && item.link +
                                                                        "?enablejsapi=1&version=3&playerapiid=ytplayer"
                                                                    }
                                                                ></iframe>
                                                            </div>
                                            )
                                        })
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            </>
        )
    }
}
export default HeroHeader;